// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__2eTe6","margin-right":"classes_margin-right__3nrdW","text":"classes_text__2-Mjc"};